import React from 'react';
import { useAppSelector } from '../app/hooks';
import { useAppDispatch } from '../app/store';
import { updateFilter } from '../features/calendar/calendar-slice';
import { CalendarEvent, FilterResponse, FilterType } from '../helpers/common-types';

export interface ListEventProps {
	event: CalendarEvent;
	categoryFilterOptions: FilterResponse[] | null;
}

export function ListEvent(props: ListEventProps) {
	const { event, categoryFilterOptions } = props;
	const dispatch = useAppDispatch();

	const currentCategoriesFilterState = useAppSelector(state => state.calendar.currentAppliedFilters[FilterType.CATEGORIES]);
	const buyTicketCtaDefaultText = useAppSelector(state => state.settings.buyTicketCtaDefaultText);
	const soldOutDefaultText = useAppSelector(state => state.settings.souldOutText);

	const isFilterApplied = (filterValue: string) => {
		const match = currentCategoriesFilterState.value.filter(appliedFilterValue => {
			return filterValue === appliedFilterValue
		});
		return match.length > 0;
	}

	const filterClicked = (e: React.MouseEvent, filterValue: string) => {
		if (categoryFilterOptions) {
			const matchingOption = categoryFilterOptions.filter(option => option.value == filterValue);
			dispatch(updateFilter({
				filterType: FilterType.CATEGORIES, newState: {
					value: [filterValue],
					firstOccurance: matchingOption[0]?.firstOccurance
				}
			}))
		}
	}

	const getTitle = (name: string | undefined) => (<h4 className="ace-cal-list-event-name h3-style" dangerouslySetInnerHTML={{ __html: name || "" }}></h4>);
	const getCta = (buyTicketText: string | undefined) => buyTicketText ? buyTicketText : buyTicketCtaDefaultText;
	const getSoldOutText = (soldOutText: string | undefined) => soldOutText || soldOutDefaultText;

	return (
		<>
			{
				!!event &&
				<li className="ace-cal-list-event">
					<article className="ace-cal-list-event-content">
						<div className="ace-cal-list-event-image">
							<a href={event?.viewDetailCtaUrl} target="_self">
								<img src={`${event.thumbnail}${event.thumbnail.indexOf('?') > 0 ? `&` : `?`}width=720&height=405&mode=crop&quality=70`} alt="" />
							</a>
						</div>
						<div className="ace-cal-list-event-details">
							<a href={event?.viewDetailCtaUrl} target="_self">
								{getTitle(event.name)}
							</a>
							<p className="ace-cal-list-event-time">{event.eventTimeString}</p>
							{
								event.location &&
								<p>{event.location}</p>
							}
							{/*Todo Availability to pass down the correct CSS class */}
							{
								event.availabilityIndicatorText &&
								<p className="availability-good" hidden={event.hideAvailability}>{event.availabilityIndicatorText}</p>
							}
							<p className="ace-cal-list-event-cta">
								{
									event.isSoldOut ?
										<>
											{getSoldOutText(event.soldOutText) && <span className="btn-primary" data-disabled>{getSoldOutText(event.soldOutText)}</span>}
										</>
										: <>
												{
													event.buyTicketCtaUrl ?
														<a href={event.buyTicketCtaUrl} data-testid="calendar purchaseTickets" onClick={(e) => {
															(e.target as HTMLElement).classList.add('btn-loading');
															(e.target as HTMLLinkElement).setAttribute('disabled', 'true');
														}} className="btn-primary">{getCta(event.buyTicketCtaText)}</a>
													:
													<span className="btn-primary" data-disabled>{getCta(event.buyTicketCtaText)}</span>
											}
										</>
								}
							</p>
						</div>
					</article>
				</li>
			}
		</>
	)
}